"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[130],{

/***/ 81130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ToastContainer; }
});

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/ReactToastify.css
var ReactToastify = __webpack_require__(40993);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/shared/components/ToastContainer/ToastContainer.tsx




var ToastContainer = function ToastContainer() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
    limit: 3,
    position: "bottom-center"
  });
};

/* harmony default export */ var ToastContainer_ToastContainer = (ToastContainer);
;// CONCATENATED MODULE: ./src/shared/components/ToastContainer/index.ts

/* harmony default export */ var components_ToastContainer = (ToastContainer_ToastContainer);

/***/ })

}]);